import { SubMenu } from "react-pro-sidebar";
import { styled } from "styled-components";

interface ActiveProps {
  active?: boolean;
  $isCollapsed?: boolean;
}

export const StyledSubMenu = styled(SubMenu)<ActiveProps>`
  color: ${({ active, theme }) =>
    active ? theme.colors.text : theme.colors.subtle};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  font-weight: 400;
  text-decoration: none;

  a {
    color: inherit !important;
    font-size: ${({ theme }) => theme.fontSizes.sm};
    font-weight: 400;
    text-decoration: none;
    background-color: ${({ theme }) => theme.colors.secondary} !important;

    &:hover {
      color: ${({ theme }) => theme.colors.text};
      background-color: ${({ theme }) => theme.colors.secondary} !important;
    }

    &.ps-active {
      color: ${({ theme }) => theme.colors.text} !important;
      background-color: ${({ theme }) => theme.colors.secondary} !important;
    }

    .ps-menu-icon {
      &.ps-active {
        color: ${({ theme }) => theme.colors.primary} !important;
        background-color: transparent !important;
      }
    }
  }

  &.ps-open {
    color: ${({ theme }) => theme.colors.text} !important;
    background-color: ${({ theme }) => theme.colors.secondary} !important;

    .ps-menu-icon {
      color: ${({ theme }) => theme.colors.primary} !important;
      background-color: transparent !important;
    }
  }

  /* &.ps-menu-button {
      padding-right: 16px;
      padding-left: 12px;
    } */

  .ps-submenu-expand-icon {
    span {
      display: ${({ $isCollapsed }) => ($isCollapsed ? "none" : "block")};
      height: 6px;
      width: 6px;
      margin-bottom: 2px;
    }
  }
`;
